import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import styles from './styles.module.scss'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import { Container } from 'react-bootstrap'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const UpcomingMatches = dynamic(() => import('@shared/components/widgets/upcomingMatches'))
const RankingTab = dynamic(() => import('@shared/components/rankingTab'))
const BreadcrumbNav = dynamic(() => import('@shared/components/breadcrumbNav'))
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function VenueLayout({ children, name }) {
  const { addTop, mobSm, addLeft, add300 } = reviveAdData
  const randomAd = Math.random() < 0.5 ? addLeft : add300

  return (
    <>
      <Container className={styles.grid_container}>
        <div>
          <div className="w-full d-none d-xl-flex justify-content-center ">
            {/* <GoogleAds
              addId={googleAddData?.addTop?.addId}
              divId={googleAddData?.addTop?.divId}
              dimension={googleAddData?.addTop?.dimension}
              slotId={googleAddData?.addTop?.slotId}
              className={'my-2'}
            /> */}
            <ReviveAds {...addTop} className={'my-2'}/>
          </div>
          <BreadcrumbNav dynamicName={name}/>
          <div className="w-full d-flex d-xl-none justify-content-center">
            {/* <GoogleAds
              addId={googleAddData?.mobSm?.addId}
              divId={googleAddData?.mobSm?.divId}
              slotId={googleAddData?.mobSm?.slotId}
              dimension={googleAddData?.mobSm?.dimension}
              className={'my-4'}
            /> */}
            <ReviveAds {...mobSm} className={'my-4'}/>
          </div>
          {children}
        </div>

        <div className="d-none d-md-block">
          <UpcomingMatches />
          {/* <GoogleAds
            addId={googleAddData?.addLeft?.addId}
            divId={googleAddData?.addLeft?.divId}
            dimension={googleAddData?.addLeft?.dimension}
            slotId={googleAddData?.addLeft?.slotId}
            className={'my-3'}
          /> */}
          <ReviveAds {...addLeft} className={'my-3'}/>
          <RankingTab />
          <ReviveAds {...add300} className={'my-3'}/>
        </div>
        <div className="d-block d-md-none d-flex justify-content-center">
          <ReviveAds {...randomAd} className={'my-3'}/>
        </div>
      </Container>
    </>
  )
}

VenueLayout.propTypes = {
  children: PropTypes.any,
  name: PropTypes.string
}

export default VenueLayout
